module.exports = __webpack_public_path__ + "static/media/nav_layout016dd5da30e1da6fd08254fbaf2ee1df.webp";